import { z } from 'zod'

import { m } from '@maestro/commerce-blocks/schemas/helpers'

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/

export const passwordField = z
  .string()
  .nonempty(m('password.required'))
  .min(8, m('password.min-length', { min: 8 }))
  .regex(passwordRegex, m('password.requirements'))
  .max(100)
